module.exports = __webpack_public_path__ + "img/about_3.d54bd066.png";